// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2MnAC","tabsBox":"styles_tabsBox__29kyS","createButton":"styles_createButton__1WlCI"};